// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"14602": "7a3e5669add1","17967": "103158ded95a","55320": "50397ecfa299","90494": "28966746c701",}[chunkId] + ".css"
}